(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("asWDE", function(module, exports) {

$parcel$export(module.exports, "openModal", function () { return $79ea014e7be98706$export$a7f6cffb6b8ba11c; });
$parcel$export(module.exports, "initModalTriggers", function () { return $79ea014e7be98706$export$41aed5761ce540ed; });

var $2Bz2x = parcelRequire("2Bz2x");

var $jZdyA = parcelRequire("jZdyA");

var $bm5yR = parcelRequire("bm5yR");
var $79ea014e7be98706$var$htmlEl = document.querySelector("html");
var $79ea014e7be98706$var$header = document.getElementById("js-site-header");
var $79ea014e7be98706$var$modalTriggerSections = document.getElementsByClassName("js-trigger-modal") ? Array.from(document.getElementsByClassName("js-trigger-modal")) : false;
var $79ea014e7be98706$var$modalElements = document.getElementsByClassName("js-modal");
var $79ea014e7be98706$var$modalCloseEvent = new Event("modalClosed");
/*
|--------------------------------------------------------------------------
| Open Modal
|
| Opens a modal with a specific ID
|--------------------------------------------------------------------------
*/ var $79ea014e7be98706$export$a7f6cffb6b8ba11c = function(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    // Open modal
    modal.classList.add("open");
    $79ea014e7be98706$var$header === null || $79ea014e7be98706$var$header === void 0 ? void 0 : $79ea014e7be98706$var$header.classList.remove("site-header--sticky");
    $79ea014e7be98706$var$htmlEl.classList.add("no-scroll");
    $79ea014e7be98706$var$htmlEl.dataset.lenisPrevent = "";
    // Add the close event
    var closeBtn = modal.querySelector(".modal-close");
    modal.addEventListener("click", function(e) {
        var target = e.target;
        if (target.classList.contains("js-modal") || target.classList.contains("modal-close")) $79ea014e7be98706$export$3f6fecd573f3fa48(modalId);
    });
};
/*
|--------------------------------------------------------------------------
| Close Modal
|
| Closes a modal with a specific ID
|--------------------------------------------------------------------------
*/ var $79ea014e7be98706$export$3f6fecd573f3fa48 = function(modalId) {
    var modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove("open");
        if ($79ea014e7be98706$var$header) (0, $2Bz2x.toggleStickyHeader)();
        $79ea014e7be98706$var$htmlEl.classList.remove("no-scroll");
        delete $79ea014e7be98706$var$htmlEl.dataset.lenisPrevent;
    }
    modal.dispatchEvent($79ea014e7be98706$var$modalCloseEvent);
};
/*
|--------------------------------------------------------------------------
| listenModalSections
|
| The scroll event that will trigger a modal once a specific element is reached.
| Used on gated content blocks to trigger the HubSpot form modals.
|--------------------------------------------------------------------------
*/ var $79ea014e7be98706$var$listenModalSections = (0, $bm5yR.throttle)(75, function() {
    $79ea014e7be98706$var$modalTriggerSections.forEach(function(section) {
        if ((0, $jZdyA.isInView)(section)) {
            var modalId = section.dataset.modalId;
            var modal = document.getElementById(modalId);
            // Open the modal
            $79ea014e7be98706$export$a7f6cffb6b8ba11c(modalId);
            // Add a close event that adds a class to this section
            modal.addEventListener("modalClosed", function() {
                console.log("test");
                section.classList.add("reveal-form");
            });
            // Remove this item from the array so it only runs once
            var sectionIndex = $79ea014e7be98706$var$modalTriggerSections.indexOf(section);
            $79ea014e7be98706$var$modalTriggerSections.splice(sectionIndex, 1);
        }
    });
    // If there are no more items, remove the event listener
    if (!$79ea014e7be98706$var$modalTriggerSections.length) window.removeEventListener("scroll", $79ea014e7be98706$var$listenModalSections);
});
/*
|--------------------------------------------------------------------------
| Init Modal Triggers
|
| Triggers and sets up the various scroll and click events for modals.
|--------------------------------------------------------------------------
*/ var $79ea014e7be98706$export$41aed5761ce540ed = function() {
    // Activate scroll events for the gated popups
    if ($79ea014e7be98706$var$modalTriggerSections) window.addEventListener("scroll", $79ea014e7be98706$var$listenModalSections);
    // Hook up the regular modal link triggers and close buttons
    if ($79ea014e7be98706$var$modalElements) Array.from($79ea014e7be98706$var$modalElements).forEach(function(modal) {
        var modalId = modal.id ? modal.id : false;
        if (!modalId) return;
        // Hook up click events on any linsk with a modal ID as the href (<a href="#modal-id">)
        var modalTriggers = document.querySelectorAll('[href="#'.concat(modalId, '"]'));
        if (modalTriggers) modalTriggers.forEach(function(e) {
            e.addEventListener("click", function() {
                $79ea014e7be98706$export$a7f6cffb6b8ba11c(modalId);
            });
        });
    });
};

});
parcelRequire.register("jZdyA", function(module, exports) {

$parcel$export(module.exports, "isInView", function () { return $e8ce3af3caa8f596$export$62976f5619263b39; });
var $e8ce3af3caa8f596$export$62976f5619263b39 = function(element) {
    var rect = element.getBoundingClientRect();
    var elTop = rect.top;
    var elBottom = rect.bottom;
    // (Partially visible elements return true)
    return elTop < window.innerHeight && elBottom >= 0;
};

});


})();
//# sourceMappingURL=modals.87fe3bf3.js.map
